/** The fields of a presenter line (Presentation + the presenter's Participant row). */
export interface OEPPresenterLineInput { PresenterName: string; Institution: string | null; CareerStage: string | null; Format: string | null; Code: string | null }

const present = (xs: readonly (string | null)[]): string[] => xs.filter((x): x is string => x !== null && x.length > 0);

/** logic.js:343 / :364 "{who} · [Institution] · [Career level] · {kind} · Session: {code}" (the code is AGU's session code); missing parts are left out. */
export function PresenterMeta(p: OEPPresenterLineInput): string {
    return [...present([p.PresenterName, p.Institution, p.CareerStage, p.Format]), ...(p.Code ? [`Session: ${p.Code}`] : [])].join(' · ');
}
